<form class="app-grid" [class.loading]="isLoading" *ngIf="model" #form="ngForm">
    <mat-form-field>
        <mat-label>{{ 'settings.workable-form.accessTokenLabel' | appTranslate }}</mat-label>
        <input
            matInput
            type="text"
            name="accessToken"
            required
            [(ngModel)]="model.accessToken"
            #accessToken="ngModel"
        />
        <mat-error *ngIf="accessToken.invalid">{{ accessToken.errors | formErrors }}</mat-error>
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{ 'settings.workable-form.subdomainLabel' | appTranslate }}</mat-label>
        <input matInput type="text" name="subdomain" required [(ngModel)]="model.subdomain" #subdomain="ngModel" />
        <mat-error *ngIf="subdomain.invalid">{{ subdomain.errors | formErrors }}</mat-error>
    </mat-form-field>
</form>
